module.exports = __webpack_public_path__ + "static/img/texun111.05fe250.png";